import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import "../../assets/styles/products/product.css";
import { Button } from "reactstrap";
import { clearCart } from "../../redux/actions/cart/cart.actions";
import { useDispatch } from "react-redux";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import axios from "axios";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PROMISE
);

export default function PaymentSuccess() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const clientSecret = searchParams.get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) return;


    stripePromise.then(async (stripe) => {

      const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);
      setStatus(paymentIntent.status);

      if(paymentIntent.status === 'succeeded'){
        dispatch(clearCart());
        window.history.replaceState({}, "", "/payment-success");

        const deliveryDetails = paymentIntent.shipping
        await axios.post(`${Server2}/orders/mark-paid`, {
          clientSecret,
          deliveryDetails,
        }, {
          headers: {
            "Content-Type": "application/json",
          },
        });

      }
    });

  }, []);

  return (
    <div className="checkout-bg">
      <div className="success-card" style={{boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px'}}>
        <div className="text-center">
          <img
            src="/img/Logo.png"
            alt="iBouge"
            height={40}
            className="mb-3"
          />

          {status === "succeeded" && (
            <>
              <div className="success-icon mb-3">✓</div>
              <h5 className="fw-semibold">Payment Successful</h5>
              <p className="text-muted mt-2">
                Thank you! Your order has been placed successfully.
              </p>

              <Button href="/" className="btn btn-ibouge w-100 mt-3">
                Continue
              </Button>
            </>
          )}

          {status === "processing" && (
            <p>Payment is processing…</p>
          )}

          {status === "requires_payment_method" && (
            <p className="text-danger">
              Payment failed. Please try again.
            </p>
          )}

          {status === "loading" && <p>Verifying payment…</p>}
        </div>
      </div>
    </div>
  );
}